import * as Yup from 'yup';

export const ReportIssueSchema = Yup.object().shape({
  trackingId: Yup.string().min(1).required('Please provide tracking id'),
  reason: Yup.string().min(1).required('Please provide rejection reason'),
});

export type ReportIssueDataType = Yup.InferType<typeof ReportIssueSchema>;

type InitialValues = {
  trackingId: string;
  reason: string;
};

export const reportIssueInitialValues: InitialValues = {
  trackingId: '',
  reason: '',
};
